import {useEffect} from 'react';
import {CategoriesApi} from "@/shared/api/CategoriesApi.ts";
import {CategoryShort} from "@/shared/model/categoryShort.ts";

export const usePersonModalCategories = (
  setCategories: (value: CategoryShort[]) => void
) => {
  useEffect(() => {
    const fetchAndSetCategories = async () => {
      try {
        const response = await CategoriesApi.getAll();
        setCategories(response.data as CategoryShort[]);
      } catch (err) {
        console.error('Error fetching categories for PersonModal:', err);
      }
    };

    void fetchAndSetCategories();
  }, [setCategories]);
};
